import React from 'react'

export default function UserList({ userAccount }) {
    const totalBalance = (arr) => {
        const balance = arr.reduce((cur, acc) => acc.moves + cur, 0);
        return balance
    }
    return (
        <div className='user-list'>
            <h3>Users List</h3>
            <table>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Username</th>
                        <th>Password</th>
                        <th>Balance</th>
                    </tr>
                </thead>
                <tbody>
                    {userAccount.map((user) => <tr key={user.id}>
                        <td><img src={user.photo} alt={user.name} className='user-icon' /></td>
                        <td>{user.name}</td>
                        <td>{user.userName}</td>
                        <td>{user.password}</td>
                        {/* <td>{user.movements.reduce}</td> */}
                        <td>₹{totalBalance(user.movements)}</td>
                    </tr>)}
                </tbody>
            </table>
        </div>
    )
}
